export default __webpack_public_path__ + "static/media/boot_1.1e714c71.bin";